import { createMuiTheme } from '@material-ui/core/styles';

export const theme = createMuiTheme({
  palette: {
      primary: { main: "#36ba8c" }, // Purple and green play nicely together.
      secondary: { main: '#000000' }, // This is just green.A700 as hex.
  },
});

export default theme;